import { StoryBlockConfig } from '@ds-mgnl/marketing';
import type { FC } from 'react';

export interface ConditionalBlockComponentProps {
	blockType: keyof typeof StoryBlockConfig;
	blockData: any;
}

export const ConditionalBlockComponent = ({
	blockType,
	blockData,
}: ConditionalBlockComponentProps) => {
	const Block = (StoryBlockConfig as Record<string, FC<any>>)[blockType];
	if (Block) {
		return <Block {...blockData} />;
	}

	console.log(`${blockType} not found.`);
	return null;
};
